import React from "react";
import {EditGuesser} from "@api-platform/admin";

const ChannelEdit = props => (
        <EditGuesser {...props} resource="channels"/>
);

export default ChannelEdit;
